import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  DOB_FOLDER_CREATE: createSagaAction('DOB_FOLDER_CREATE'),
  DOB_FOLDERS_FETCH: createSagaAction('DOB_FOLDERS_FETCH'),
  DOB_FOLDERS_DELETE: createSagaAction('DOB_FOLDERS_DELETE'),
  DOB_FOLDERS_UPDATE: createSagaAction('DOB_FOLDERS_UPDATE'),

  UPLOAD_DOB_FOLDER_ATTACHMENT: createSagaAction('UPLOAD_DOB_FOLDER_ATTACHMENT'),
  GET_DOB_FOLDER_ATTACHMENTS: createSagaAction('GET_DOB_FOLDER_ATTACHMENTS'),
  UPDATE_DOB_FOLDER_ATTACHMENT_DESCRIPTION: createSagaAction(
    'UPDATE_DOB_FOLDER_ATTACHMENT_DESCRIPTION'
  ),
  DELETE_DOB_FOLDER_ATTACHMENT: createSagaAction('DELETE_DOB_FOLDER_ATTACHMENT')
}

// Action Creators
export const actions = {
  createDobFolder: ({ jobId, name }) => ({
    type: constants.DOB_FOLDER_CREATE.ACTION,
    jobId,
    name
  }),

  fetchDobFolders: ({ jobId }) => ({
    type: constants.DOB_FOLDERS_FETCH.ACTION,
    jobId
  }),

  deleteDobFolder: ({ dobAttachmentFolderId, jobId }) => ({
    type: constants.DOB_FOLDERS_DELETE.ACTION,
    dobAttachmentFolderId,
    jobId
  }),

  updateDobfolder: ({ name, dobAttachmentFolderId, jobId }) => ({
    type: constants.DOB_FOLDERS_UPDATE.ACTION,
    name,
    dobAttachmentFolderId,
    jobId
  }),

  // Attachment actions
  uploadDobAttachment: ({ formData, dobAttachmentFolderId }) => ({
    type: constants.UPLOAD_DOB_FOLDER_ATTACHMENT.ACTION,
    formData,
    dobAttachmentFolderId
  }),

  getDobAttachments: ({ dobAttachmentFolderId }) => ({
    type: constants.GET_DOB_FOLDER_ATTACHMENTS.ACTION,
    dobAttachmentFolderId
  }),

  updateDobAttachmentDescription: ({
    attachmentId,
    dobAttachmentFolderId,
    description,
    userId
  }) => ({
    type: constants.UPDATE_DOB_FOLDER_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    dobAttachmentFolderId,
    description,
    userId
  }),

  deleteDobAttachment: ({ attachmentId, dobAttachmentFolderId }) => ({
    type: constants.DELETE_DOB_FOLDER_ATTACHMENT.ACTION,
    attachmentId,
    dobAttachmentFolderId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.DOB_FOLDER_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.DOB_FOLDERS_FETCH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.DOB_FOLDERS_FETCH.SUCCESS:
      return {
        ...state,
        loading: false,
        dobFolders: action.payload
      }

    case constants.UPLOAD_DOB_FOLDER_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_DOB_FOLDER_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    case constants.GET_DOB_FOLDER_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_DOB_FOLDER_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        jobDobAttachments: action.payload,
        loadingAttachments: false
      }

    case constants.UPDATE_DOB_FOLDER_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_DOB_FOLDER_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_DOB_FOLDER_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/dobAttachmentActions.js